/**
 * Cloudflare Turnstile site key loading.
 *
 * The site key is public by design (like SUPABASE_ANON_KEY). We load it from
 * the Edge Function (`TURNSTILE_SITE_KEY` secret) so Vercel does not need a
 * REACT_APP_* build-time variable.
 *
 * Optional local override: REACT_APP_TURNSTILE_SITE_KEY
 */

import { fetchTurnstileSiteKey } from "../api/selfRegister";

let cachedSiteKey = String(process.env.REACT_APP_TURNSTILE_SITE_KEY ?? "").trim();
let loadPromise = null;

export function getCachedTurnstileSiteKey() {
  return cachedSiteKey;
}

export function isTurnstileConfigured() {
  return cachedSiteKey.length > 10;
}

/**
 * @returns {Promise<string>} site key or ""
 */
export async function loadTurnstileSiteKey() {
  if (cachedSiteKey.length > 10) {
    return cachedSiteKey;
  }
  if (!loadPromise) {
    loadPromise = (async () => {
      const res = await fetchTurnstileSiteKey();
      if (res.ok && res.siteKey) {
        cachedSiteKey = res.siteKey;
      }
      return cachedSiteKey;
    })().finally(() => {
      loadPromise = null;
    });
  }
  return loadPromise;
}
